  <template>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="visible"
        width="800px"
        @close="visible = false"
        top="6vh">
        <el-form
          class="diy-top-form"
          :model="form"
          ref="ruleForm"
          label-width="120px"
          label-position="top">
          <el-form-item
            label="安全风险名称:"
            prop="name"
            :rules="{required: true, message: '请输入名称', trigger: 'blur'}">
            <el-input
              v-model="form.name"
              placeholder="请输入名称"
              class="width-percent-80"
              size="small"></el-input>
          </el-form-item>
          <el-form-item label="事故类型:" >
            <el-select
              multiple
              size="small"
              clearable
              class="width-percent-80"
              placeholder="事故类型（多选）"
              v-model="form.typeList">
              <el-option
                v-for="item in options.type"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="风险等级:"  prop="level" :rules="{required: true, message: '请选择风险等级', trigger: 'change'}">
            <template v-if="form.level===null">
              <div
                class="mr-20"
                style="border:1px dashed #F5F5F5;background-color: #F5F5F5; height: 124px;width: 240px;text-align: center;line-height: 124px" >
                暂无风险等级
              </div>
              <div class="assessWord"
                   @click="assessDialogShow=true">
                <i class="el-icon-edit"></i>
                <span>点击评估</span>
              </div>
            </template>
            <div v-else style="width: 240px">
               <div
                  style="height:34px;"
                  class="color-white display-flex pl-14 pr-14"
                  :style="{background: levelColor(form.level?.level)}">
                  <p class="margin-0">{{form.level?.level | levelName}}</p>
                </div>
                <div
                  style="height: 44px;"
                  class="display-flex pl-20"
                  :style="{background: levelSubColor(form.level?.level)}">
                  <p v-if="form.level?.type === '1'" class="fs-12 margin-0"><b>直接判断法</b></p>
                  <p v-if="form.level?.type === '2'" class="fs-12 margin-0"><b>LS法：</b> R=L×S {{ form.level?.R }}={{ form.level?.L }}×{{ form.level?.S }}</p>
                  <p v-if="form.level?.type === '3'" class="fs-12 margin-0"><b>LEC法：</b> D=L×E×C {{ form.level?.D }}={{ form.level?.L }}×{{ form.level?.E }}×{{ form.level?.C }}</p>
                </div>
                <div class="assessWord"
                   @click="assessDialogShow=true">
                <i class="el-icon-edit"></i>
                <span>修改评估</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="风险代码:">
            <el-input
              v-model="form.fxCode"
              placeholder="请输入风险代码"
              class="width-percent-80"
              size="small"></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select
            class="width-percent-80"
            clearable
            placeholder="请选择状态"
            v-model="form.state" size="small">
            <el-option
              v-for="item in options.state"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="时态:">
            <el-select
            class="width-percent-80"
            clearable
            placeholder="请选择时态"
            v-model="form.tense" size="small">
            <el-option
              v-for="item in options.tense"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="管控措施:" required>
            <div v-if="form.measures" style="padding: 0 10px 10px 10px">
              <div
                v-for="(item, index) in form.measures"
                :key="index"
                class="mb-10">
                <div class="display-flex ai-center">
                  <img width="14px" :src="item.icon" alt="">
                  <b class="fs-12 ml-10">{{item.title}}</b>
                  <i v-if="!item.list.length" class="el-icon-plus" @click="addMeasure(item)"></i>
                </div>
                <draggable v-model="item.list">
                    <div class="display-flex ai-center"
                         style=" cursor: move;"
                         v-for="(_item,index) in item.list"
                         :key="_item.id">
                      <img width="14px" :src="drag" alt="可进行拖拽排序" class="mr-20">
                      {{index+1}}、
                      <el-input size="small" placeholder="请输入" v-model="_item.name" :ref="_item.id"></el-input>
                      <i class="el-icon-plus mr-10 ml-10 color-primary  cursor-pointer" @click="addMeasure(item)" ></i>
                      <i class="el-icon-delete color-danger cursor-pointer" @click="delMeasure(item,_item) "></i>
                    </div>
                </draggable>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button type="primary" @click="submitForm" :loading="loading">确认</el-button>
          <el-button @click="visible = false">取消</el-button>
        </template>
      </el-dialog>
      <AssessToolDialog v-if="assessDialogShow" :show="assessDialogShow" @getSelMethod="getSelMethodData" @close="assessDialogShow=false"></AssessToolDialog>
    </div>
  </template>

<script>
import icon1 from '@/assets/images/risk/icon1.png'
import icon2 from '@/assets/images/risk/icon2.png'
import icon3 from '@/assets/images/risk/icon3.png'
import icon4 from '@/assets/images/risk/icon4.png'
import icon5 from '@/assets/images/risk/icon5.png'
import drag from '@/assets/images/risk/drag.png'
import draggable from 'vuedraggable'
import AssessToolDialog from '@/views/basicLibrary/risk/AssessToolDialog';
export default {
  name: 'harmAddDialog',
  components: { AssessToolDialog, draggable },
  props: {
    id: {
      type: String,
      default: ''
    },
    selectedRisk: {
      type: Object,
      default: null
    },
    operateType: {
      type: String,
      default: 'add'
    },
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      drag: drag,
      options: {
        type: [],
        state: [
          { value: 1, label: '正常' },
          { value: 2, label: '异常' },
          { value: 3, label: '紧急' }
        ],
        tense: [
          { value: 1, label: '过去' },
          { value: 2, label: '现在' },
          { value: 3, label: '将来' }
        ]
      },
      form: {},
      loading: false,
      assessDialogShow: false
    }
  },
  filters: {
    levelName (val) {
      switch (val) {
        case '4':
          return '重大风险'
        case '3':
          return '较大风险'
        case '2':
          return '一般风险'
        case '1':
          return '低风险'
      }
    }
  },
  computed: {
    title () {
      if (this.operateType === 'edit') {
        return '编辑'
      } else {
        return '新增'
      }
    },
    visible: {
      get () {
        return this.show;
      },
      set (visible) {
        this.$emit('update:show', visible);
      }
    }
  },
  watch: {
    visible () {
      return this.show
    }
  },
  methods: {
    // addOneData (item) {
    //   item.list.push({
    //     name: '',
    //     id: ''
    //   })
    // },
    close () {
      this.$emit('close', false)
    },
    /**
       * 提交表单
       * @param formName
       */
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.form.measures.some(item => item.list.length) >= 1) {
            this.$message.warning('请填写管控措施')
          } else {
            const data = {
              decisionMethodValue: JSON.stringify(this.form.level),
              fxCode: this.form.fxCode,
              state: this.form.state,
              tense: this.form.tense,
              fxAccidentTypeIdList: this.form.typeList,
              fxDbId: this.selectedRisk.id,
              fxDecisionMethodId: this.form.level?.type,
              fxGradeId: this.form.level?.level,
              harmFactor: this.form.name,
              measure: JSON.stringify(this.form.measures)
            }
            if (this.form.id) {
              data.id = this.form.id
              this.$api.riskLibrary.harmFactorUpdate(data).then(res => {
                this.$message.success('编辑成功')
                this.$emit('refreshData')
                this.visible = false
              })
            } else {
              this.$api.riskLibrary.harmFactorSave(data).then(res => {
                this.$message.success('添加成功')
                this.$emit('refreshData')
                this.visible = false
              })
            }
          }
        }
      });
    },
    /**
       * 风险等级对应颜色
       * @param id
       * @returns {string}
       */
    levelColor (id) {
      switch (id) {
        case '4':
          return '#FF4A4A'
        case '3':
          return '#F6B300'
        case '2':
          return '#F9E14A'
        case '1':
          return '#326BFF'
      }
    },
    /**
       * 风险等级对应副系颜色
       * @param id
       * @returns {string}
       */
    levelSubColor (id) {
      switch (id) {
        case '4':
          return '#FFF0F0'
        case '3':
          return '#FFFAEB'
        case '2':
          return '#FFFEF6'
        case '1':
          return '#EAF0FF'
      }
    },
    getSelMethodData (data) {
      this.form.level = data
      this.assessDialogShow = false
    },
    /**
       * 添加管控措施
       * @param data
       */
    addMeasure (data) {
      console.log(data)
      const id = Math.floor(Math.random() * 10) + this.$moment().unix()
      if (data.list.length) {
        if (data.list[data.list.length - 1].name) {
          data.list.push({
            name: '',
            id
          })
        } else {
          this.$message.warning('请先填写完成上一条管控措施')
        }
      } else {
        data.list.push({
          name: '',
          id
        })
      }
      // const id = Math.floor(Math.random() * 10) + this.$moment().unix()
      // if (data.list.length) {
      //   if (data.list[data.list.length - 1].name) {
      //     data.list.push({
      //       name: '',
      //       id
      //     })
      //     // this.$nextTick(() => {
      //     //   this.$refs[id][0] && this.$refs[id][0].focus();// 获取输入框，自动获取焦点
      //     // })
      //   } else {
      //     this.$message.warning('请先填写完成上一条管控措施')
      //   }
      // } else {
      //   console.log(1111)
      //   data.list.push({
      //     name: '',
      //     id
      //   })
      //   this.$nextTick(() => {
      //     this.$refs[id][0] && this.$refs[id][0].focus()
      //   })
      // }
    },
    /**
       * 删除管控措施
       * @param data
       */
    delMeasure (item, _item) {
      this.$confirm('确定删除这条管控措施吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        item.list = item.list.filter(__item => __item.id !== _item.id)
      }).catch(() => {})
    }
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
    this.$api.riskLibrary.getTypeList().then(res => {
      this.options.type = res
    })
    if (this.operateType === 'edit') {
      this.$api.riskLibrary.harmFactorInfo({ id: this.id }).then(res => {
        console.log('edit=====', res, JSON.parse(res.decisionMethodValue), JSON.parse(res.measure))
        console.log(JSON.parse(res.measure))
        this.form = {
          id: res.id,
          name: res.harmFactor,
          typeList: res.fxAccidentTypeIds.split(','),
          level: JSON.parse(res.decisionMethodValue),
          fxCode: res.fxCode,
          state: res.state,
          tense: res.tense,
          measures: res.measure ? JSON.parse(res.measure) : [
            {
              icon: icon4,
              title: '工程技术措施：',
              list: []
            },
            {
              icon: icon3,
              title: '管理方法措施：',
              list: []
            },
            {
              icon: icon2,
              title: '教育培训措施：',
              list: []
            },
            {
              icon: icon5,
              title: '个体防护措施：',
              list: []
            },
            {
              icon: icon1,
              title: '应急处置措施：',
              list: []
            }
          ]
        }
        console.log(this.form.measures)
      })
    } else {
      this.form = {
        id: '',
        name: '',
        typeList: [],
        level: null,
        fxCode: '',
        atate: '',
        tense: '',
        measures: [
          {
            icon: icon4,
            title: '工程技术措施：',
            list: []
          },
          {
            icon: icon3,
            title: '管理方法措施：',
            list: []
          },
          {
            icon: icon2,
            title: '教育培训措施：',
            list: []
          },
          {
            icon: icon5,
            title: '个体防护措施：',
            list: []
          },
          {
            icon: icon1,
            title: '应急处置措施：',
            list: []
          }
        ]
      }
    }
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

  <style lang="scss" scoped>
  .assessWord{
    width: 68px;
    margin-top: 12px;
    color:#1774FF;
    cursor: pointer;
    background-color: #BFD7FF;
    border-radius: 4px;
    padding: 8px 12px 8px 14px;
    font-size: 12px;
    height: 12px;
    line-height: 12px;
  }
  </style>
